export default __webpack_public_path__ + "static/media/menu_settings.ad8f3518.svg";